/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SearchDTOCompany } from './SearchDTOCompany';
import {
    SearchDTOCompanyFromJSON,
    SearchDTOCompanyFromJSONTyped,
    SearchDTOCompanyToJSON,
} from './SearchDTOCompany';
import type { SearchDTOTeam } from './SearchDTOTeam';
import {
    SearchDTOTeamFromJSON,
    SearchDTOTeamFromJSONTyped,
    SearchDTOTeamToJSON,
} from './SearchDTOTeam';

/**
 * 
 * @export
 * @interface SearchDTO
 */
export interface SearchDTO {
    /**
     * 
     * @type {number}
     * @memberof SearchDTO
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SearchDTO
     */
    guid: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDTO
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SearchDTO
     */
    firstName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDTO
     */
    lastName: string | null;
    /**
     * 
     * @type {SearchDTOTeam}
     * @memberof SearchDTO
     */
    team: SearchDTOTeam;
    /**
     * 
     * @type {SearchDTOCompany}
     * @memberof SearchDTO
     */
    company: SearchDTOCompany;
    /**
     * 
     * @type {string}
     * @memberof SearchDTO
     */
    access: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchDTO
     */
    role: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchDTO
     */
    active: boolean;
}

/**
 * Check if a given object implements the SearchDTO interface.
 */
export function instanceOfSearchDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "guid" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "team" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "access" in value;
    isInstance = isInstance && "role" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function SearchDTOFromJSON(json: any): SearchDTO {
    return SearchDTOFromJSONTyped(json, false);
}

export function SearchDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'guid': json['guid'],
        'email': json['email'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'team': SearchDTOTeamFromJSON(json['team']),
        'company': SearchDTOCompanyFromJSON(json['company']),
        'access': json['access'],
        'role': json['role'],
        'active': json['active'],
    };
}

export function SearchDTOToJSON(value?: SearchDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'guid': value.guid,
        'email': value.email,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'team': SearchDTOTeamToJSON(value.team),
        'company': SearchDTOCompanyToJSON(value.company),
        'access': value.access,
        'role': value.role,
        'active': value.active,
    };
}

